import { render } from "./clientnumberNew.vue?vue&type=template&id=34e12ebe&scoped=true"
import script from "./clientnumberNew.vue?vue&type=script&lang=js"
export * from "./clientnumberNew.vue?vue&type=script&lang=js"

import "./clientnumberNew.vue?vue&type=style&index=0&id=34e12ebe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e12ebe"]])

export default __exports__